var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 18.75C19.375 19.0952 19.0952 19.375 18.75 19.375H1.625C1.07272 19.375 0.625 18.9273 0.625 18.375V1.25C0.625 0.904823 0.904822 0.625 1.25 0.625C1.59518 0.625 1.875 0.904822 1.875 1.25V17.125C1.875 17.6773 2.32272 18.125 2.875 18.125H18.75C19.0952 18.125 19.375 18.4048 19.375 18.75Z",
    fill: "#273043",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.875C7.5 16.4273 7.05228 16.875 6.5 16.875H4.125C3.57272 16.875 3.125 16.4273 3.125 15.875V9.125C3.125 8.57272 3.57272 8.125 4.125 8.125H6.5C7.05228 8.125 7.5 8.57272 7.5 9.125V15.875Z",
    fill: "#273043",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15.875C13.125 16.4273 12.6773 16.875 12.125 16.875H9.75C9.19772 16.875 8.75 16.4273 8.75 15.875V7.25C8.75 6.69772 9.19772 6.25 9.75 6.25H12.125C12.6773 6.25 13.125 6.69772 13.125 7.25V15.875Z",
    fill: "#273043",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.736 15.875C18.736 16.4273 18.2882 16.875 17.736 16.875H15.361C14.8087 16.875 14.361 16.4273 14.361 15.875V4.75C14.361 4.19772 14.8087 3.75 15.361 3.75H17.736C18.2882 3.75 18.736 4.19772 18.736 4.75V15.875Z",
    fill: "#273043",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImp);
export default __webpack_public_path__ + "static/media/imp.11d6d33c342bf5fe8fccbc6cf5da3756.svg";
export { ForwardRef as ReactComponent };